import React from 'react';

const pasos = [
  {
    numero: '1',
    titulo: 'Diagnóstico',
    descripcion: 'Conocemos las necesidades y objetivos de tu organización.',
  },
  {
    numero: '2',
    titulo: 'Diseño',
    descripcion: 'Creamos una propuesta personalizada para tu equipo.',
  },
  {
    numero: '3',
    titulo: 'Implementación',
    descripcion: 'Desarrollamos actividades dinámicas, prácticas y participativas.',
  },
  {
    numero: '4',
    titulo: 'Evaluación',
    descripcion: 'Medimos resultados y proponemos mejoras continuas.',
  },
];

const ComoTrabajamos = () => {
  return (
    <section id="como-trabajamos" className="section bg-white">
      <div className="container max-w-4xl">
        <div className="text-center mb-14">
          <h2 className="heading-2">
            Un proceso claro, <em>de principio a fin</em>
          </h2>
        </div>

        <div className="pasos-grid">
          {pasos.map((paso) => (
            <div key={paso.numero} className="paso">
              <span className="paso-numero" aria-hidden="true">
                {paso.numero}
              </span>
              <h3 className="heading-3 mb-2">{paso.titulo}</h3>
              <p className="body-medium">{paso.descripcion}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ComoTrabajamos;
